export enum PreviewCommands {
    EditBlock = 'editBlock',
    FocusBlock = 'focusBlock',
    ToggleEditMode = 'toggleEditMode',
    AddBlock = 'addBlock',
    SyncState = 'syncState',
    Ready = 'ready',
    Initialize = 'initialize',
    ErrorBlock = 'errorBlock',
}
